<div class="content-area">
  <div class="clr-row">
    <div class="clr-col-12 clr-col-md-8 post-wrapper">
      <div class="featured-image-wrapper"></div>
      <h1 class="text-center">Contact</h1>
      <div class="post-content">
        <div>
          Mail direct la
          <b><a target="_blank"
             rel="noopener noreferrer"
             href="mailto:funbible.net@gmail.com"
          >funbible.net@gmail.com
          </a></b>
          sau prin formularul de mai jos.
        </div>
        <app-loading-component *ngIf="isLoading"></app-loading-component>
        <form clrForm clrLayout="horizontal" *ngIf="!isLoading">
          <clr-input-container>
            <label>Nume</label>
            <input clrInput type="text" [(ngModel)]="name" name="name" />
          </clr-input-container>
          <clr-input-container>
            <label>Email</label>
            <input clrInput type="email" [(ngModel)]="email" name="email" />
          </clr-input-container>
          <clr-input-container>
            <label>Subiect</label>
            <input clrInput type="text" [(ngModel)]="subject" name="subject" />
          </clr-input-container>
          <clr-textarea-container>
            <label>Mesaj</label>
            <textarea clrTextarea type="text" [(ngModel)]="message" name="message"></textarea>
          </clr-textarea-container>
          <button class="orange-button mt-4 float-right" type="submit" (click)="submit()">Trimite</button>
        </form>
      </div>
    </div>
  </div>
</div>
